import { SvgIcon, SvgIconProps } from '@mui/material'
import React from 'react'

const PasswordDesktopLockIcon: React.FC<SvgIconProps> = (props) => {
  const { sx, viewBox = '0 0 59 58', ...rest } = props
  return (
    <SvgIcon viewBox={viewBox} sx={{ stroke: '#676767', fill: 'none', ...sx }} {...rest}>
      <path
        d="M17.5834 18.7202C17.0771 18.7202 16.6667 19.1142 16.6667 19.6002C16.6667 20.0862 17.0771 20.4802 17.5834 20.4802C18.0896 20.4802 18.5 20.0862 18.5 19.6002C18.5007 19.3666 18.4043 19.1424 18.2323 18.9773C18.0602 18.8121 17.8267 18.7196 17.5834 18.7202V18.7202"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.75 18.7202C26.2437 18.7202 25.8333 19.1142 25.8333 19.6002C25.8333 20.0862 26.2437 20.4802 26.75 20.4802C27.2562 20.4802 27.6666 20.0862 27.6666 19.6002C27.6673 19.3666 27.5709 19.1424 27.3989 18.9773C27.2268 18.8121 26.9933 18.7196 26.75 18.7202V18.7202"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M27.6666 26.6401H11.1666C10.1541 26.6401 9.33331 25.8521 9.33331 24.8801V14.3201C9.33331 13.348 10.1541 12.5601 11.1666 12.5601H27.6666"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.1667 44.2402C33.3754 48.0131 34.6423 51.6617 36.8334 54.8002H22.1667C24.3578 51.6617 25.6246 48.0131 25.8334 44.2402"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16.6667 54.7998H42.3334" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M2 37.2002H57" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M57 37.2V40.72C57 42.664 55.3584 44.24 53.3333 44.24H5.66667C3.64162 44.24 2 42.664 2 40.72V5.52C2 3.57596 3.64162 2 5.66667 2H31.3333"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35 14.0601C35 13.2316 35.6716 12.5601 36.5 12.5601H55.5C56.3284 12.5601 57 13.2316 57 14.0601V28.6601C57 29.4885 56.3284 30.1601 55.5 30.1601H36.5C35.6716 30.1601 35 29.4885 35 28.6601V14.0601Z"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.6667 12.56V9.04C38.6667 5.15192 41.9499 2 46 2V2C50.0501 2 53.3334 5.15192 53.3334 9.04V12.56"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46 20.48C45.4937 20.48 45.0833 20.874 45.0833 21.36C45.0833 21.846 45.4937 22.24 46 22.24C46.5062 22.24 46.9166 21.846 46.9166 21.36C46.9173 21.1264 46.8209 20.9022 46.6489 20.737C46.4768 20.5719 46.2433 20.4794 46 20.48V20.48"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SvgIcon>
  )
}

export default PasswordDesktopLockIcon
